import React from 'react';
import { Table, Icon, Button, Modal, Popconfirm, message } from 'antd';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import ModalSchoolAdmin from '../../components/ModalSchoolAdmin'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'

class STAdminAdmins extends React.Component {

  constructor() {
    super();
    this.state = {
      modalOpen: false,
      modalData: null,
      toRemove: null,
    }
  }

  removeEntry = (mode) => {
      if( this.state.toRemove) {
        this.props.firebase.database().ref('users/'+this.state.toRemove).remove();
        this.setState({toRemove: null})
      }
  }


  saveModal = (data, mode) => {

    this.modal.cancel();
    let dob = 'DD/MM/YYYY'

    if (mode == 'edit') {
      this.props.firebase.database().ref('users/'+data.id+'/profile').update({
        id: data.id,
        name: data.first,
        last_name: data.last
      })
      this.props.firebase.database().ref('users/'+data.id+'/profile/school').update({
        id: data.schoolid,
        name: data.school,
      })
      this.props.firebase.database().ref('/users/'+data.id+'/roles/').remove()
      this.props.firebase.database().ref('/users/'+data.id+'/roles/'+data.schoolid).set({
        "0": 'admin'
      })
    } else {
      message.success('Invitation email sent');
      this.props.firebase.database().ref('/invites').push({
        name: data.first,
        last_name: data.last,
        email: data.email,
        school_name: data.school,
        school_id: data.schoolid,
        role: 'admin',
        id: false
      })
    }

  }

  cancelModal = () => {
    this.setState({modalOpen: false, modalData: null})
  }

  openModal = (mode, data) => {
    this.setState({modalOpen: true, modalData: data, modalMode: mode},
      () => {
        this.modal.updateData();
      })
  }

  removeSchoolFromAdmin = (data) => {

    this.props.firebase.database().ref('/users/'+data.userid+'/roles/'+data.schoolid).remove()
  }

  addSchoolToAdmin = (schoolid, userid) => {

    this.props.firebase.database().ref('/users/'+userid+'/roles/'+schoolid).set({
      "0": 'admin'
    })
  }

  render() {
    //Map users data to table
    let data = []
    let allSchools;
    const { t } = this.props;
    if (this.props.users && this.props.schools) {
      let users = Object.entries(this.props.users)
       users.map( (user, i) => {
         //Find school Id-s where user is admin, then find the names of that school
         //Filteredschools = schools where the user is has admin role

        let schoolIds = []
        if (user[1].roles) {
          schoolIds = Object.entries(user[1].roles);
        }
        schoolIds = schoolIds.filter( id => id[1].includes('admin'))
        allSchools = Object.entries(this.props.schools)
        let schools = [];
        let filteredschools = [];
        schoolIds.map( (id, i) => {
          filteredschools[i] = allSchools.filter( school =>
            school[0] == id[0]
          )
        })

        //Only push to table if user is admin in amy school
        if (filteredschools.length >0 && filteredschools[0].length > 0) {
            data.push(
              {
                id: user[0],
                key: i,
                first: user[1].profile.name,
                last: user[1].profile.last_name,
                email: user[1].profile.email,
                school: filteredschools.map( school => school[0][1].name),
                schoolid: filteredschools.map( school => school[0][0]),
                edit: <Icon style={{fontSize: '24px'}} type="edit" />,
                delete:       <Popconfirm placement="top" title={t('Are you sure you want to remove this admin? All the connected data will be deleted as well.')} onConfirm={() => this.removeEntry()} okText={t("Yes")} cancelText={t("No")}>
                                <Icon style={{fontSize: '24px'}} type="delete" />
                              </Popconfirm>,
              }
            )
      }
      })

    }

    const columns = [
            {
              title: 'First name',
              dataIndex: 'first',
              key: 'first',
              sorter: true,
            },
            {
              title: 'Last name',
              dataIndex: 'last',
              key: 'last',
              sorter: true,
            },
            {
              title: 'Email',
              dataIndex: 'email',
              key: 'email',
              sorter: true,
            },
            {
              title: 'Schools',
              dataIndex: 'school',
              key: 'school',
              sorter: true,
            },
            {
              title: '',
              dataIndex: 'edit',
              key: 'edit',
              width: '50',
              onCell: (record) => {
                return {
                  onClick: () => {this.openModal('edit', record)}
                  };
                }
            },
            {
              title: '',
              dataIndex: 'delete',
              key: 'delete',
              width: '50',
              onCell: (record) => {
                return {
                  onClick: () => {this.setState({toRemove: record.id})}
                  };
                }
            },
            {
              title: '',
              dataIndex: 'archive',
              key: 'archive',
              width: '80',
              onCell: (record) => {
                return {
                  onClick: () => {this.setState({toRemove: record.id})}
                  };
                }
            },

    ]

    return (
      <div>
        <div style={styles.container}>
        <div style={styles.submenu}>
        <Icon style={styles.logout} type="unlock" onClick={() => this.props.firebase.logout()} />
        <Button
          onClick={() => this.openModal('add')}
          style={styles.buttonBlue} type="primary"
        >
          <Icon type="user-add"/>{t('Add school admin')}
        </Button>
        </div>
        <div style={styles.inner}>
          <Table
            id='log-table'
            columns={columns}
            dataSource={data}
          />
        </div>
        </div>
        <ModalSchoolAdmin
          mode={this.state.modalMode}
          ref={instance => { this.modal = instance; }}
          allschools={allSchools}
          data={this.state.modalData}
          open={this.state.modalOpen}
          save={(data, mode) => this.saveModal(data,mode)}
          cancel={this.cancelModal}
          t={this.props.t}
        />
      </div>
    )
  }
}

const enhancer = compose(
  translate('lang'),
  firebaseConnect((props) => {
    return [
      'users', 'schools'
    ]
  }),
  connect(
    state => ({
      users: state.firebase.data.users,
      schools: state.firebase.data.schools
    })
  )
)
export default enhancer(STAdminAdmins);

const styles = {

  container: {
    padding: '20px',
  },

  logout: {
    fontSize: '30px',
    float: 'right',
    marginLeft: '10px',
    cursor: 'pointer'
  },

  buttonBlue: {
    float: 'right',
    fontSize: '17px',
    backgroundColor: '#4A90E2',
    border: 'none',
    fontSize: '14px',
    borderRadius: '15px',
  },

  submenu: {
    marginBottom: '20px',
    overflow: 'hidden'
  },

  inner: {
    padding: 20,
    backgroundColor: 'white',
    boxShadow: '0 1px 3px 1px rgba(119,151,178,0.16)'
  }
}



// WEBPACK FOOTER //
// ./src/containers/STAdminAdmins/index.jsx